import React from 'react';
import { withRouter} from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

import LandingLayout from 'component/page/landing';
import EarlyAccessCTA from 'component/content/early_access';
import PortfolioBuild from 'component/content/portfolio_build';
import Popular from 'component/content/popular';
import Custom from 'component/content/custom';


class Page extends React.Component {
  render (){
    return (
      <LandingLayout id="landing-page">
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>

        <PortfolioBuild />

        <div className="bg-secondary my-5">
        <Custom />
        </div>

        <Popular />

        <div className="bg-dark">
          <EarlyAccessCTA text_colour="white"/>
        </div>


      </LandingLayout>
    )
  }
}

export default withRouter(Page);
